export const logDebug = (...args) => {
  console.log("[DEBUG][BOOSTER]:", ...args);
};
